const packageVersion = import.meta.env.VITE_PACKAGE_VERSION;
const buildNumber = import.meta.env.VITE_BUILD_NUMBER;
const gitSha = import.meta.env.VITE_GIT_SHA;

const shortSha = gitSha ? gitSha.substring(0, 7) : '';
const buildSegment = buildNumber ? `+${buildNumber}` : '';
const shaSegment = shortSha ? `-${shortSha}` : '';

export const APP_VERSION = `${packageVersion}${buildSegment}${shaSegment}`;
